export default __webpack_public_path__ + "static/media/msg-notice.d5259350.svg";